import { root } from "@/common/consts";

export default {
    props: {
        slug: {
            type: String,
            required: true
        },
        definitions: {
            type: Array,
            required: true
        },
        headword: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            root
        };
    },
    computed: {
        styledHeadword() {
            return `"` + `<strong>` + `${this.headword}` + `</strong>` + `"`;
        }
    },
    methods: {
        trackDefinition() {
            this.$ga.event({
                eventCategory: "Definition",
                eventAction: "Open definition"
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/PopOut/PopOut.js